export default __webpack_public_path__ + "CDFS-methodology.pdf";